import { useEffect, useState } from 'react';

/**
 * The value, once it has stopped changing for `delay` ms. Use it as the
 * dependency of a fetch effect so typing in a search box sends one request
 * when the user pauses, not one per keystroke. Clearing the box applies at
 * once.
 */
export const useDebouncedValue = (value, delay = 300) => {
    const [debounced, setDebounced] = useState(value);

    useEffect(() => {
        if (value === '' || value === null || value === undefined) {
            setDebounced(value);
            return undefined;
        }
        const timeoutId = setTimeout(() => setDebounced(value), delay);
        return () => clearTimeout(timeoutId);
    }, [value, delay]);

    return debounced;
};

export default useDebouncedValue;
